import { render, staticRenderFns } from "./legendBox3.vue?vue&type=template&id=5bb0b600&scoped=true&"
import script from "./legendBox3.vue?vue&type=script&lang=js&"
export * from "./legendBox3.vue?vue&type=script&lang=js&"
import style0 from "./legendBox3.vue?vue&type=style&index=0&id=5bb0b600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0b600",
  null
  
)

export default component.exports